import React, { useState } from "react";
import { Link } from "react-router-dom";
import ResendBookingForm from "../components/Login/ResendBookingForm";
import { validateBooking } from "../utils/requestHandler";
import { toast } from "react-toastify";
import TwoFactorAuthModal from "../components/Login/2FactorAuthModal";
import Loader from "../components/Loader";

const LoginPage = () => {
  const [bookingNumber, setBookingNumber] = useState("");
  const [lastName, setLastName] = useState("");
  const [showResendBookingPopup, setShowResendBookingPopup] = useState(false);
  const [showTwoFactorPopup, setShowTwoFactorPopup] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [userDetails, setUserDetails] = useState({
    mobile_no: "",
    email: "",
    booking_id: "",
    guest_id: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!bookingNumber || !lastName) alert("Please fill in all fields");
    setShowLoader(true);
    validateBooking({
      booking_id: bookingNumber,
      last_name: lastName,
    }).then((res) => {
      setShowLoader(false);
      if (res?.status === "success") {
        setUserDetails({
          mobile_no: res.mobile_no,
          email: res.email,
          booking_id: res.booking_id,
          guest_id: res.guest_id,
        });
        toast.success(res.message);
        setShowTwoFactorPopup(true);
      } else {
        toast.error(res?.message);
      }
    });
  };
  return (
    <div>
      <img
        src={`${process.env.PUBLIC_URL}/assets/login/login-banner.png`}
        className="w-full h-[200px] md:h-auto"
        alt="logo"
      />
      <div className="flex flex-col items-center justify-center md:min-h-screen">
        <div className="bg-white p-8 rounded max-w-md w-full">
          <h2 className="text-2xl font-bold text-center text-mv-darkblue mb-4">
            LOGIN HERE
          </h2>
          <p className="text-[#707070] pb-4 text-center ">
            Please enter your login details here.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="bookingNumber"
                className="block font-semibold text-mv-darkblue"
              >
                BOOKING CONFIRMATION #
              </label>
              <input
                autoFocus
                type="text"
                id="bookingNumber"
                value={bookingNumber}
                onChange={(e) => setBookingNumber(e.target.value)}
                className="w-full px-3 py-2 border rounded"
                placeholder="Booking Confirmation #"
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="lastName"
                className="block font-semibold text-mv-darkblue"
              >
                LAST NAME
              </label>
              <input
                type="text"
                id="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSubmit(e);
                }}
                className="w-full px-3 py-2 border rounded"
                placeholder="Enter Last Name of Primary Guest"
              />
            </div>
            <button
              type="submit"
              className="w-full bg-mv-darkblue text-white py-2 rounded hover:bg-blue-800 transition duration-300"
            >
              LOGIN
            </button>
          </form>
          <div className="text-center mt-4">
            <Link
              onClick={() => setShowResendBookingPopup(!showResendBookingPopup)}
              className="text-blue-900 font-bold underline hover:underline"
            >
              Resend booking number?
            </Link>
          </div>
        </div>
      </div>
      {showResendBookingPopup && (
        <ResendBookingForm
          setShowResendBookingPopup={setShowResendBookingPopup}
        />
      )}
      {showTwoFactorPopup && (
        <TwoFactorAuthModal
          userDetails={userDetails}
          onClose={() => setShowTwoFactorPopup(false)}
        />
      )}
      {<Loader isLoading={showLoader} />}
    </div>
  );
};

export default LoginPage;
